import { useEffect, useRef, useState } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useNavigate,
    createSearchParams
} from "react-router-dom";
import MTable from '../../Components/MTable/MTable';
import MInput from '../../Components/Input';
import Overlay from '../../Components/Overlay';
import MTextarea from '../../Components/TextArea';
import { createPayment, getPayment, getPaymentById } from '../../Service/Payment';
import { NumberFormat } from '../../Components/NumberFormat';
import moment from 'moment';
import Swal from 'sweetalert2';
import { handlerFormError, uuid, isObjectEmpty } from '../../Utils/Utils';

const { $ } = window;
let processingId = -1;
const Payment = () => {

    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [state, setState] = useState({
        amount: 0,
        remark: '',
        tanggal: moment().format('YYYY-MM-DD')
    })
    const mTable = useRef();
    const onAddData = () => {
        $("#modal-payment").modal();
    }

    const onView = item => () => {
        navigate("/operationalcost/view/" + item.id);
    };

    const onDateChange = (event) => {
        setState({ ...state, tanggal: event.target.value });
    }

    const onChangeAmount = (e) => {
        let val = e.target.value;
        /*if(val < 1) {
            val = 1;
        }*/
        const regex_test = val.match(/^[0-9]*$/);
        const limit = 10 ** 10;
        if(!regex_test || regex_test.length <=0){
            setErrors({...errors, amount: "Amount must be an integer"})
        }
        else if(val >= limit ) setErrors({...errors, amount: "The cost is above the maximum limit provided"})
        else if(!val) setErrors({...errors, amount: "Amount is not provided"})
        else {
            delete errors.amount
            setErrors({...errors});
        };
        setState({ ...state, amount: val })
    }

    const onHideModal = () => {
        $("#modal-payment").modal('hide');
    }

    const onSubmit = () => {
        let message = "";
        if (state.amount == 0 || state.amount == "") {
            message += "Amount must be greater than 0! \n";
        } else if (state.remark == "") {
            message += "Remark required! \n";
        } else if (state.tanggal == "") {
            message += "Date required! \n";
        }
        if (message != "") {
            Swal.fire({
                icon: 'error',
                timer: 1500,
                showConfirmButton: false,
                title: "Please correct form",
                text: message
            });
            return;
        }
        let payload = {
            u_m_bank_amt: state.amount,
            u_m_doc_date: state.tanggal,
            line_items: [
                {
                    remarks: state.remark,
                    amount: state.amount,
                    id: uuid()
                }
            ]
        }

        $("#modal-payment").modal('hide');

        navigate("/operationalcost/create", {
            state: payload
        });
    }

    const columns = [
        { id: 1, title: 'No Payment', field: 'docnum', sortable: true },
        { id: 2, title: 'Total Amount', field: 'u_m_bank_amt', sortable: true, render: data => { return NumberFormat(data.u_m_bank_amt) } },
        { id: 3, title: 'Created Date', field: 'created_date', sortable: true, filter_text: "Please type in this format: 'YYYY-MM-DD', example: 2023-03-01. You can also exclude the date, or month. Example : 2023-03 and 2023"},
        {
            id: 4,
            title: 'Status',
            field: 'status',
            sortable: true,
            render: data => {
                var text = "";
                if (data.status == 'CANCELED') {
                    text = <span className="badge bg-red me-2">{data.status}</span>;
                } else if (data.status == 'PAID') {
                    text = <span className="badge bg-paid me-2">{data.status}</span>;
                } else if (data.status == 'CLOSE') {
                    text = <span className="badge bg-close me-2">{data.status}</span>;
                } else if (data.status == 'OPEN') {
                    text = <span className="badge bg-cyan me-2">{data.status}</span>;
                }
                return text;
            },
        },
        {
            id: 5,
            title: 'Action',
            render: item => {
                return (
                    <div>
                        <a
                            onClick={onView(item)}
                            style={{
                                cursor: 'pointer',
                                display: 'inline-block',
                                marginRight: 20
                            }}
                        >
                            <i className="fas fa-eye" />
                            <span style={{ marginLeft: 10 }}>View</span>
                        </a>

                    </div>
                );
            },
        },
    ];

    const propsTable = { columns, getData: getPayment, showIndex: true, showAddButton: true, onAddData, order: 'created_date', direction: 'desc' };

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h2 className="title-breadcrum">Operational Cost</h2>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="card shadow mb-4">
                        <div className="card-body">
                            <div className='table-responsive'>
                                <MTable ref={mTable}  {...propsTable} />
                            </div>
                        </div>
                    </div>
                    <div id="modal-payment" className='modal' >
                        <Overlay display={state.processing} />
                        <div className='modal-dialog modal-dialog-centered modal-lg'>
                            <div className='modal-content'>
                                <div className='modal-header'>
                                    <h5 className="modal-title"> New Payment</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className='modal-body'>
                                    <div className='row' style={{ padding: '10px 65px' }}>
                                        <div className='col-sm-12'>
                                            <MInput
                                                name='amount'
                                                label='Amount'
                                                type='number'
                                                min={1}
                                                step={1}
                                                value={state.amount}
                                                onChange={e => onChangeAmount(e) }
                                                required
                                            />
                                            {errors && errors.amount && <span style={{color:"red"}}>{errors.amount}</span>}
                                        </div>
                                    </div>

                                    <div className='row' style={{ padding: '10px 65px' }}>
                                        <div className='col-sm-12'>
                                            <div className="mb-3">
                                                <MTextarea label='Remark'
                                                    name='remark'
                                                    rows={3}
                                                    required
                                                    readOnly={false}
                                                    onChange={e => setState({ ...state, remark: e.target.value })}
                                                    value={state.remark} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row' style={{ padding: '10px 65px' }}>
                                        <div className='col-sm-12'>
                                            <MInput
                                                id='tanggal'
                                                name='tanggal'
                                                label='Date'
                                                type='date'
                                                value={state.tanggal}
                                                icon={<i className="bi bi-calendar3"></i>}
                                                onChange={onDateChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className='row' style={{ justifyContent: 'flex-end', padding: '10px 65px' }}>
                                        <div className='col-sm-2'>
                                            <button className="btn btn-readonly btn-block" style={{ marginBottom: 30 }} type="button" onClick={onHideModal} >
                                                Cancel
                                            </button>
                                        </div>
                                        <div className='col-sm-2'>
                                            <button className="btn btn-modena btn-block" disabled={!isObjectEmpty(errors)} style={{ marginBottom: 30 }} type="button" onClick={onSubmit} >
                                                Submit
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );

};

export default Payment;